/**
 * Where to send the user after sign-in when an MCP OAuth connection (claude.ai and
 * other MCP clients) is waiting on them: the /oauth/login or /oauth/consent URL with
 * its signed query. Session storage, so it dies with the tab like the flow itself.
 */

const KEY = 'pendingOAuthReturn'

export function rememberOAuthReturn(): void {
  try {
    sessionStorage.setItem(KEY, `${window.location.pathname}${window.location.search}`)
  } catch {
    // Storage blocked: the user restarts the connection from the client.
  }
}

/** The pending return path (only same-origin /oauth/ paths), cleared once read. */
export function takeOAuthReturn(): string | null {
  try {
    const value = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return value?.startsWith('/oauth/') ? value : null
  } catch {
    return null
  }
}
